import { Card, CardContent } from "../../components/ui/card";
import { Users, Building2 } from "lucide-react";

const EmployeeStats = ({ stats, departments, designations }) => {
  // Support both naming conventions: total/active (from hook) and totalEmployees/activeEmployees
  const totalEmployees = stats?.totalEmployees ?? stats?.total ?? 0;
  const activeEmployees = stats?.activeEmployees ?? stats?.active ?? 0;
  
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-violet-100">
              <Users className="h-5 w-5 text-violet-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{totalEmployees}</p>
              <p className="text-xs text-slate-500">Total Employees</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-emerald-100">
              <Users className="h-5 w-5 text-emerald-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{activeEmployees}</p>
              <p className="text-xs text-slate-500">Active</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-blue-100">
              <Building2 className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{departments?.length || stats?.departments || 0}</p>
              <p className="text-xs text-slate-500">Departments</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card className="card-soft">
        <CardContent className="p-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-lg bg-amber-100">
              <Users className="h-5 w-5 text-amber-600" />
            </div>
            <div>
              <p className="text-2xl font-bold text-slate-800">{designations?.length || stats?.designations || 0}</p>
              <p className="text-xs text-slate-500">Designations</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmployeeStats;
